import React, { useContext } from 'react';
import { Field } from 'formik';
import { FormControl, Grid, InputLabel, TextField, Select, FormHelperText } from '@material-ui/core';
import helpers from 'app/utils/helpers';
import { FormServiceContext } from 'app/utils/contexts';
import CustomMaskField from 'app/internalPages/Lines/components/MaskField';

const SubstituteConductor = (props) => {
    const { classes, errors } = props;
    const { canEdit } = useContext(FormServiceContext);

    const validateDocument = (value) => {
        let error;
        if (!value || !helpers.validateCpfCnpj(value)) {
            error = 'Documento inválido';
        }
        return error;
    };

    const validateRequired = (value) => {
        let error;
        if (!value || value === '') {
            error = 'Campo obrigatório';
        }
        return error;
    };

    return (
        <>
            <Grid item container xs={12} spacing={3}>
                <Grid item xs={12}>
                    <h3 className={classes.titleTable}>Condutor(a) Substituto(a):</h3>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Field
                        component={CustomMaskField}
                        label="CPF"
                        name="condutor.deCpf"
                        mask={'999.999.999-99'}
                        margin="dense"
                        variant="filled"
                        disabled={!canEdit}
                        validate={validateDocument}
                        error={Boolean(errors.condutor?.deCpf)}
                        helperText={Boolean(errors.condutor?.deCpf) ? errors.condutor?.deCpf : ''}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        as={TextField}
                        name="condutor.deNome"
                        label="Nome"
                        margin="dense"
                        variant="filled"
                        disabled={!canEdit}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        validate={validateRequired}
                        error={Boolean(errors.condutor?.deNome)}
                        helperText={Boolean(errors.condutor?.deNome) ? errors.condutor?.deNome : ''}
                        inputProps={{
                            maxLength: 100,
                        }}
                    />
                </Grid>
            </Grid>
            <Grid item container xs={12} spacing={3}>
                <Grid item xs={12} sm={3}>
                    <Field
                        as={TextField}
                        name="condutor.deCnh"
                        label="Carteira de Habilitação"
                        margin="dense"
                        variant="filled"
                        disabled={!canEdit}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        validate={validateRequired}
                        error={Boolean(errors.condutor?.deCnh)}
                        helperText={Boolean(errors.condutor?.deCnh) ? errors.condutor?.deCnh : ''}
                        inputProps={{
                            maxLength: 11,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <FormControl
                        variant="filled"
                        margin="dense"
                        fullWidth
                        error={Boolean(errors.condutor?.tpCategoriaCnh)}>
                        <InputLabel htmlFor="flLinha" shrink={true}>
                            Categoria
                        </InputLabel>
                        <Field
                            as={Select}
                            native
                            name="condutor.tpCategoriaCnh"
                            disabled={!canEdit}
                            validate={validateRequired}>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="AB">AB</option>
                            <option value="C">C</option>
                            <option value="AC">AC</option>
                            <option value="D">D</option>
                            <option value="AD">AD</option>
                            <option value="E">E</option>
                            <option value="AE">AE</option>
                        </Field>
                        {errors.condutor?.tpCategoriaCnh ? (
                            <FormHelperText>{errors.condutor?.tpCategoriaCnh}</FormHelperText>
                        ) : null}
                    </FormControl>
                </Grid>
            </Grid>
        </>
    );
};

export default SubstituteConductor;
